import { environment } from '@environments/environment'

export const APIEndpoints = {

    /**General Dropdown API Endpoints */
    authentication: `${environment.baseURL}/authorization`,
    getLocationData: `${environment.baseURL}/common/location`,
    getAreaData: `${environment.baseURL}/common/area`,
    getDepartmentData: `${environment.baseURL}/common/departmentlist`,
    getSuperVisorList: `${environment.baseURL}/common/supervisorlist`,
    getStateList: `${environment.baseURL}/common/statelist`,
    getProgramList: `${environment.baseURL}/common/programlist`,
    getEmployeeTypeList: `${environment.baseURL}/common/employeetypelist`,
    getAppList: `${environment.baseURL}/common/applist`,
    getCountList: `${environment.baseURL}/common/countlists`,

    /**Person Page API Endpoints */
    getAllEmployee: `${environment.baseURL}/person/list`,
    getSearchData: `${environment.baseURL}/person/search`,
    getFilterData: `${environment.baseURL}/person/filter`,
    getPersonDetails: `${environment.baseURL}/person/persondetail`,

    /** OnBoarding API Endpoints */

    getCreatedAndAllocatedData: `${environment.baseURL}/request/getdomainentiyandallocation`,
    generateEntityID: `${environment.baseURL}/request/allocateentity`,
    deallocateAllocatedID: `${environment.baseURL}/request/deletedomainentityandallocation`,

    /**Draft Page API Endpoints */
    saveDraft: `${environment.baseURL}/draft/save`,
    getDraftList: `${environment.baseURL}/draft/list`,
    getDraftDetails: `${environment.baseURL}/draft/detail`,
    getDraftFilterData: `${environment.baseURL}/draft/filter`,
    submitNonEmployeeRequest: `${environment.baseURL}/request/nonemployeeworkflowsubmit`,
    submitNonEmployeeRequestAutoApproval: `${environment.baseURL}/draft/nonemployeeautoapproval`,
    submitSystemAccessRequest: `${environment.baseURL}/request/apprequestworkflow`,

    /** Staff Page API Endpoints */
    getStaffListData: `${environment.baseURL}/staff/mystaff`,
    getDepartListData: `${environment.baseURL}/staff/mydepartment`,
    getStaffFilterData: `${environment.baseURL}/staff/mystafffilter`,
    getDepartmentFilterData: `${environment.baseURL}/staff/mydepartmentfilter`,

    /** History details API Endpoints */
    getRequestDetails: `${environment.baseURL}/common/accessrequestlog`,
    getDepartmentDetails: `${environment.baseURL}/common/departmentlog`,
    getJobDetails: `${environment.baseURL}/common/jobtitlechanges`,
    getManagerDetails: `${environment.baseURL}/common/managerlog`,

    /** System Access details API Endpoints */
    getSystemAccessDetails: `${environment.baseURL}/common/systemaccessrequestlog`,
    getSystemAccessCompleteHistory: `${environment.baseURL}/common/systemaccessrequesthistory`,
    getMyStaffList: `${environment.baseURL}/staff/mystaff`,
    getMyDepartmentList: `${environment.baseURL}/staff/mydepartment`,
    getSystemAccessHistory: `${environment.baseURL}/common/apprequesttracking`,
    getManagerUpdateHistory: `${environment.baseURL}/common/managerrequesttracking`,
    getProgramUpdateHistory: `${environment.baseURL}/common/programrequesttracking`,
    getJobTitleUpdateHistory: `${environment.baseURL}/common/jobtitlerequesttracking`,
    getAccessEndUpdateHistory: `${environment.baseURL}/common/accessendrequesttracking`,
    getContactUpdateHistory: `${environment.baseURL}/common/contactinfoupdaterequesttracking`,

    /** Request details API Endpoints */
    getRequestDetailsData: `${environment.baseURL}/request/specificdetails`,
    getPendingApprovalList: `${environment.baseURL}/request/pendingapproval`,
    getSubmittedList: `${environment.baseURL}/request/requestsubmited`,
    getProcessedList: `${environment.baseURL}/request/requestprocessed`,
    getReturnedList: `${environment.baseURL}/request/returnsmodification`,
    getFilterSearchList: `${environment.baseURL}/request/requesttabfiltersearch`,
    downloadUpdateProof: `${environment.baseURL}/person/getFileFromContainer`,

    /** Update details modal API endpoints */
    updateManagerDetails: `${environment.baseURL}/request/personmanagerupdate`,
    updateProgramDetails: `${environment.baseURL}/request/personprogramupdate`,
    updateJobDetails: `${environment.baseURL}/request/personjobupdate`,
    updateContactDetails: `${environment.baseURL}/person/contactinformationupdate`,
    updateDateDetails: `${environment.baseURL}/request/accessendrequestwf`,
    staffNameListData: `${environment.baseURL}/common/listofpersonbysupervisor`,
    updateLastNameDetails: `${environment.baseURL}/person/updatePersonLastNameWithFile`
}
